import { render } from "./CandidatesList.vue?vue&type=template&id=54d5aca4"
import script from "./CandidatesList.vue?vue&type=script&lang=js"
export * from "./CandidatesList.vue?vue&type=script&lang=js"

import "./CandidatesList.vue?vue&type=style&index=0&id=54d5aca4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__